var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('img',{attrs:{"src":require("@/assets/logo1.png")}}),_c('div',{class:[_vm.clickMenu?'img-div2':'img-div'],on:{"click":_vm.showMenu}},[_c('img',{attrs:{"src":require("@/assets/menu.png")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }